import React, { Component } from "react";
import { GameStatus } from "../../common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
	faCircleCheck,
	faCircleExclamation,
	faClock,
	faCircleXmark,
	faUserSecret,
} from "@fortawesome/free-solid-svg-icons";

import styles from "./index.module.scss";

interface Props {
	status: GameStatus;
}

export class IconInfo extends Component<Props> {
	public renderIcon (icon: IconProp, variant: string, title: string): JSX.Element {
		return <span
			className={ `${ styles.badge } ${ styles[variant] }` }
			title={ title }
		>
			<FontAwesomeIcon icon={ icon } className={ styles.icon } />
		</span>
	}
	public render (): JSX.Element {
		switch (this.props.status) {
			case GameStatus.Confirmed:
				return this.renderIcon(faCircleCheck, "confirmed", "Confirmed");
			case GameStatus.Unconfirmed:
				return this.renderIcon(faCircleExclamation, "unconfirmed", "Unconfirmed");
			case GameStatus.Pending:
				return this.renderIcon(faClock, "pending", "Pending");
			case GameStatus.Hidden:
				return this.renderIcon(faUserSecret, "hidden", "Hidden");
			case GameStatus.Removed:
				return this.renderIcon(faCircleXmark, "removed", "Removed");
		}
		throw new Error("Invalid status");
	}
}
